<template>
    <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
            <v-btn
                v-bind="attrs"
                v-on="on"
                icon
                small
                rounded
                class="mr-2"
                @click="handleClick">
                <v-icon :class="iconClass" :aria-label="label">{{ icon }}</v-icon>
            </v-btn>
        </template>

        <template v-slot:default>
            <div class="py-1 px-3 d-flex align-center">
                <v-icon
                    v-if="!allowed"
                    color="white"
                    small
                    class="mr-1">
                    mdi-lock-outline
                </v-icon>
                <span>{{ label }}</span>
            </div>
        </template>
    </v-tooltip>
</template>

<script>
export default {
    props: {
        icon: {
            type: String,
            required: true
        },
        label: {
            type: String,
            required: true
        },
        allowed: {
            type: Boolean,
            required: true
        },
        iconClass: {
            type: String,
            default: ''
        },
    },
    emits: ['action'],
    methods: {
        handleClick() {
            if (this.allowed) {
                this.$emit('action')
            } else {
                EventBus.fire('subscription-prompt')
            }
        },
    },
}
</script>
